module.exports = __webpack_public_path__ + "img/2.590c3e24.svg";